export default __webpack_public_path__ + "static/media/peep-28.c11a40b3.svg";